(function () {
    'use strict';

    angular
        .module('app')
        .directive('recentChanges', recentChangesDirective);

    function recentChangesDirective() {
        var directive = {
            restrict: 'AE',
            scope: {
                pk: '=',
                updateTime: '=',
                targetModel: '@',
            },
            controller: recentChangesDirectiveController,
            controllerAs: 'vm',
            bindToController: true,
            templateUrl: '/templates/directives/recent-changes.directive.html',
        };


        return directive;
    }

    recentChangesDirectiveController.$inject = ['API', 'debug', 'alert', 'helpers', '$scope', '$timeout',];

    function recentChangesDirectiveController(API, debug, alert, helpers, $scope, $timeout) {
        var vm = this;
        vm.loadingState = {
            logs: false,
        };
        vm.logs = [];
        vm.seeChanges = seeChanges;
        activate();

        function activate() {
            loadLogs();
            $scope.$watch('vm.updateTime', function (newValue, oldValue) {
                // If resource got updated, also update logs
                if (newValue && newValue !== oldValue) {
                    loadLogs();
                }
            });
        }

        function loadLogs() {
            vm.loadingState.logs = true;
            if (vm.pk) {
                var promise = API.AdminLogs.search({
                    'target_pk': vm.pk,
                    'per-page': 10,
                    sort: '-created',
                    expand: 'user,target',
                    target_model: vm.targetModel,
                }).$promise;

                promise.then(function (response) {
                    if (response.items) {
                        vm.logs = [];

                        angular.forEach(response.items, function (item) {

                            /**
                             * Change the action type
                             */
                            if (item.changes && item.changes.type === 'give-credit') {
                                item.action = 'credit';
                            }

                            vm.logs.push(item);
                        });
                    }
                }, function () {
                    debug.log('Error loading comments.');
                })
                    .finally(function () {
                        vm.loadingState.logs = false;
                    });
            } else {
                $timeout(function () {
                    loadLogs();
                }, 1000);
            }
        }

        function seeChanges(log) {
            alert.open('log-changes', { changes: helpers.printObject(log.changes) });
        }
    }

})();